import React, { useState, useEffect } from "react"
import NZFinancialServicesRegulatoryFramework from "./NZFinancialServicesRegulatoryFramework"
import AiForWorkflowAndProductivity from "./AiForWorkflowAndProductivity"
import FundamentalsOfAiInEducation from "./FundamentalsOfAiInEducation"
import AdvancedFundamentalsOfAiInEducation from "./AdvancedFundamentalsOfAiInEducation"
import IntroductionOfAiCreation from "./IntroductionOfAiCreation"
// used for custom nested pages. E.g. Finance/NZ Financial Services Regulatory Framework (Bridging Course)
const CustomCourseContent = ({ content }) => {
  const [c, setC] = useState()
  const key = content != undefined ? content : ""

  useEffect(() => {
    if (key === "NZFinancialServicesRegulatoryFramework") {
      setC(<NZFinancialServicesRegulatoryFramework />)
    }
    else if (key === "AiForWorkflowAndProductivity") {
      setC(<AiForWorkflowAndProductivity />)
    }
    else if (key === "FundamentalsOfAiInEducation") {
      setC(<FundamentalsOfAiInEducation />)
    }
    else if (key === "AdvancedFundamentalsOfAiInEducation") {
      setC(<AdvancedFundamentalsOfAiInEducation />)
    }
    else if (key === "IntroductionOfAiCreation") {
      setC(<IntroductionOfAiCreation />)
    }
    else {
      console.log(`${key} - Custom content key does not match subjects.json`)
    }
  }, [])
  return <div>{c}</div>
}

export default CustomCourseContent
